import styled from '@emotion/styled';

export const TeamContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;

  &.left {
    justify-content: end;

    .score {
      margin-left: 12px;
    }
  }

  &.right {
    justify-content: start;

    .score {
      margin-right: 12px;
    }
  }
`;

export const GameCardContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 24px;
  gap: 16px;
  justify-content: space-between;

  height: 73px;

  background: #ffffff;
  border-bottom: 1px solid #eaeaec;

  flex: none;
  order: 1;
  flex-grow: 0;

  &:last-child {
    border-radius: 0 0 8px 8px;
    border-bottom: none;
  }
`;

export const GameCardTime = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;
  width: 80px;
`;

export const GameCardTeams = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
`;

export const TeamsDelimiterContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 6px;
`;

export const TeamsDelimiter = styled.div`
  width: 4px;
  height: 4px;

  border-radius: 4px;
  background-color: #d9b244;
`;

export const GameTeamScore = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 17px;
  font-weight: 600;
`;

export const IconButton = styled.button<{ color?: string }>`
  cursor: pointer;
  background: transparent;
  border: none;
  color: ${({ color }) => color};

  transition: color 0.25s ease;
  &:hover {
    color: #d9b244;
  }
`;

export const GameActions = styled.div`
  min-width: 188px;
  text-align: right;
  display: flex;
  justify-content: center;
  gap: 14px;

  .game-action-btn:first-of-type {
    margin-left: 0;
  }
`;
